

async function fetchApiDian(PathUrl = '', requestOptions) {

    let UrlBase = localStorage.getItem('AmbienteApiDian_Url');

    return await fetch(UrlBase + PathUrl, requestOptions)
        .then((response) => response.json())
        .then(response => {
            console.log(response, 'ok ' + PathUrl);
            return response;
        }, error => {
            console.log(error, 'error');
            alert('Algo salio mal, por favor verifica');
            return error;
        })

}


export { fetchApiDian }